'use client';
import React from "react";
import ImageGallery from "react-image-gallery";
import { Image } from "../../../types";
import { useResizeHook } from "../../../lib";

export default function ServiceCategoryRowGallery({ images }: { images: Image[] }) {
    const disableSwipe = true;
    const { greaterThanTailwindMd768 } = useResizeHook();

    return (
        <div className="md:col-span-12 col-span-12">
            <div
                className="
                    [&_.image-gallery-slide-wrapper]:pointer-events-none
                "
            >
                {!!images?.length && (
                    <ImageGallery
                        items={!greaterThanTailwindMd768 ? [images[0]] : images}
                        showThumbnails={false}
                        showBullets={false}
                        showNav={false}
                        showPlayButton={false}
                        fullScreenButton={false}
                        showFullscreenButton={false}
                        disableSwipe={disableSwipe}
                    />
                )}
            </div>
        </div>
    );
}
